import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AppRoutes, ROUTE_PATHS } from './shared/constants/app-routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: ROUTE_PATHS[AppRoutes.HOME],
    pathMatch: 'full'
  },
  {
    path: ROUTE_PATHS[AppRoutes.HOME],
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.CREATE_PQRS],
    loadComponent: () => import('./features/create-pqrs/create-pqrs.component').then(m => m.CreatePqrsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.CREATE_PUBLIC_PQRS],
    loadComponent: () => import('./features/create-public-pqrs/create-public-pqrs.component').then(m => m.CreatePublicPqrsComponent)
  },
  {
    path: ROUTE_PATHS[AppRoutes.PQRS_DETAILS] + '/:id',
    loadComponent: () => import('./features/pqrs-details/pqrs-details.component').then(m => m.PqrsDetailsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.CHANGE_PASSWORD],
    loadComponent: () => import('./shared/components/change-password/change-password.component').then(m => m.ChangePasswordComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.UNAUTHORIZED],
    loadComponent: () => import('./shared/components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: '**',
    redirectTo: ROUTE_PATHS[AppRoutes.HOME]
  }
];
